import { Location_BufferStop } from "@opstel/gen/knop/ui/v1/model/location_pb";
import { createSchema, ZodOutputFor } from "../zod-utils";
import { pointSchema } from "./point";
import { PlainMessage } from "@bufbuild/protobuf";
import { z } from "zod/v3";
import { Point } from "@opstel/geo/Point";

export interface BufferStop {
  code: string;
  coordinate: Point;
  connection: string;
}

export const bufferStopSchema = createSchema<BufferStop, PlainMessage<Location_BufferStop>>({
  code: z.string().min(1, "BufferStop code should not be empty"),
  coordinate: pointSchema,
  connection: z.string().min(1, "BufferStop connection should not be empty"),
}) satisfies ZodOutputFor<BufferStop>;
